import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import apis from '../../../apis'
import { axiosDelete, axiosGet, axiosPost } from '../../../axiosHelper'

interface Challenge {
  count_registration: number
  end_time: string
  start_time: string
  title_en: string
  title_ko: string
  uuid: string
}

interface ChallengeData {
  challenge_program: Challenge
  registered: boolean
}

const fetchChallenge = async (): Promise<ChallengeData> => {
  const response = await axiosGet(apis.challenge.siliconValleyChallenge.active())
  return response
}

export const useFetchChallenge = (config = {}) => {
  return useQuery({
    queryKey: ['challenge'],
    queryFn: () => fetchChallenge(),
    ...config,
  })
}

interface ChallengeApplyResponse {
  message: string
  success: boolean
}

const fetchChallengeApply = async (uuid: string): Promise<ChallengeApplyResponse> => {
  const response = await axiosPost(apis.challenge.siliconValleyChallenge.apply(uuid))
  return response
}

export const useChallengeApply = (config = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['challengeApply'],
    mutationFn: (uuid: string) => fetchChallengeApply(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['challenge'] })
    },
    ...config,
  })
}

const fetchMyChallengeStatus = async () => {
  const response = await axiosGet(apis.challenge.siliconValleyChallenge.me())
  return response
}

export const useFetchMyChallengeStatus = (config = {}) => {
  return useQuery({
    queryKey: ['myChallengeStatus'],
    queryFn: () => fetchMyChallengeStatus(),
    ...config,
  })
}

const handleRemove = async (uuid: string) => {
  const response = await axiosDelete(apis.challenge.siliconValleyChallenge.apply(uuid))
  return response
}

export const useRemoveChallenge = (config = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['removeChallenge'],
    mutationFn: (uuid: string) => handleRemove(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['challenge'] })
    },
    ...config,
  })
}
